import cloneDeep from 'lodash.clonedeep';

const getInitialstate = (state) => {
  let initialState = state || cloneDeep(window.initialState);
  return initialState;
};

export default getInitialstate;
